module.exports = __webpack_public_path__ + "img/room4.ed8af4de.jpeg";